import React, { useState, useEffect, useCallback, lazy, Suspense } from "react";
import Box from "@mui/material/Box";
import { Typography, CircularProgress, Paper, Alert } from "@mui/material";
import "./SFTPSummary.css";

// This is the component we want to load dynamically
// In a real application, this would come from a database or API
const componentToLoad = "CompletionGroupProduction";

function SFTPSummary() {
  const [DynamicComponent, setDynamicComponent] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        setLoading(true);
        // In a real application, this path would be determined dynamically
        // based on data from a database or API
        const module = await import(`../DynamicComponentExamples/${componentToLoad}.js`);
        setDynamicComponent(() => module.default);
        setError(null);
      } catch (err) {
        console.error("Failed to load dynamic component:", err);
        setError(`Failed to load component: ${err.message}`);
        setDynamicComponent(null);
      } finally {
        setLoading(false);
      }
    };

    loadComponent();
  }, [componentToLoad]);

  return (
    <Box sx={{ p: 2 }}>
      
      <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
        
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        )}
        
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        
        {!loading && !error && DynamicComponent && (
          <Box sx={{ mt: 2 }}>
            <DynamicComponent />
          </Box>
        )}
      </Paper>
    </Box>
  );
}

export default SFTPSummary;
